import React, {Component} from 'react';
import { Link } from "react-router";
import PropTypes from 'prop-types';
import { database, auth } from '../firebase';
var randomstring = require("randomstring");

class Report extends Component {
  constructor(props) {
    super(props);
    this.reportId = randomstring.generate(20);
    this.opened = props.opened;
    this.state = {
      opened: this.opened,
      content: "",
    }
    this.aç = this.aç.bind(this);
    this.kapat = this.kapat.bind(this);
    this.gönder = this.gönder.bind(this);
  }


  aç() {
    document.getElementById(this.reportId+"report-div").style.display = "block";
    setTimeout(function() {
      document.getElementById("inpıt").focus();
    }, 50)
  }

  kapat() {
    document.getElementById(this.reportId+"report-div").style.display = "none";
  }

  gönder() {
    if (this.state.content == "") return alert("Kusura bakma ama olmayan hataları çözemeyiz :D");
    else if (this.state.content.toLowerCase() == "sorun var") return this.animate();
    database.ref("reports").push().set({
      author: auth.currentUser.uid,
      content: this.state.content,
      date: Date.now(),
      //TODO:öncelik: düşük/orta/yüksek
    });
    document.getElementById("report-div").style.display = "none";
    alert("Gönderildi, teşekkürler!")
    this.setState({content: ""})
  }

  animate() {
    document.getElementById("report-image").style.top = "24%";
    setTimeout(function() {
      document.getElementById("report-image").style.top = "50%";
    }, 10000)
  }

  render() {
    if (this.props.opened == true) this.aç();
    return (
    <div style={this.state.opened == false ? {display: "none"} : {display: "block"}} id={this.reportId+"report-div"}>
      <div className="overlay"></div>
      <div className="report">
        <a>Geri Bildirim Gönder</a>
        <p>Bize düşüncelerini söyleyebilirsin! Aklını okuyamayız sonuçta...</p>
        <input type="text" value={this.state.content} onChange={event => this.setState({content: event.target.value})} id="inpıt"/><br/>
        <a><button className="red" onClick={this.kapat}>İptal</button></a>
        <a><button className="onay" onClick={this.gönder}>Gönder</button></a>
      </div>
      <Link to="https://www.youtube.com/watch?v=WRzOwJdqCqg" target="blank">
        <img className="report-image" id="report-image" src="https://images.genius.com/cea3fee61f0de1be51e0bff096e99289.640x640x1.jpg"/>
      </Link>

      <style>{`
        .overlay {
          top: 0;
          left: 0;
          background: #000;
          position: fixed;
          width: 100%;
          height: 100%;
          opacity: 0.4;
          z-index: 99;
        }

        .report {
          top: 50%;
          margin-top: -150px;
          left: 50%;
          margin-left: -200px;
          background: #fff;
          width: 400px;
          height: 220px;
          opacity: 1;
          z-index: 999;
          position: fixed;
          border-radius: 5px;
          text-align: center;
          padding: 20px 10px;
        }

        .report a {
          color: #000;
          font-size: 30px;
          font-weight: bold;
        }

        .report p {
          color: #000;
          font-size: 18px;
          margin-top: 15px;
        }

        .report-image {
          width: 100px;
          height: 100px;
          display: block;
          position: fixed;
          top: 50%;
          left: 50%;
          margin-left: -40px;
          z-index: 998;
          transition: .2s;
        }

        .report-image:hover {
          -webkit-transform: scale(1.05);
          -ms-transform: scale(1.05);
          -moz-transform: scale(1.05);
          transform: scale(1.05);
        }

        .report input {
          width: 250px;
          border: 2px solid #ccc;
          padding: 10px;
          border-radius: 5px;
          outline: none;
        }

        .report input:focus {
          border: 2px solid #F57029;
        }

        .report button {
          margin-top: 4%;
          outline: none;
          min-width: 100px;
        }

        .onay {
          padding: 10px;
          background: #ccc;
          border: 1px solid #000;
        }

        .onay:hover {
          background: #F57029;
          color: #fff;
        }

        .red {
          padding: 10px;
          margin-right: 10px;
          background: none;
          border: 1px solid #000;
        }

        .red:hover {
          background: #000;
          color: #fff;
        }

        @media (max-width: 623px) {
          .report {
            width: 100%;
            height: 100%;
            left: 0;
            padding: 20px 0px;
            margin: 0;
          }
        }
      `}</style>

    </div>
  )}
}

Report.propTypes = {
  opened: PropTypes.bool,
}
export default Report;